module.exports = __webpack_public_path__ + "img/pr-5.2aa50ce1.png";